/**
 * Content validation utilities
 * Checks if content has meaningful text worth encrypting
 */

import { InlineContent, TextNode } from '../transforms/ast'

/**
 * Check if inline content has significant (non-whitespace) text
 * @param content Array of inline content nodes
 * @returns true if content has non-whitespace text
 */
export function hasSignificantContent(content: InlineContent[]): boolean {
  if (!content || content.length === 0) {
    return false
  }

  const text = content
    .filter((node) => node.type === 'text')
    .map((node) => (node as TextNode).text)
    .join('')

  return text.trim().length > 0
}

/**
 * Check if a text string has significant content
 * @param text Text string to check
 * @returns true if text has non-whitespace content
 */
export function hasSignificantText(text: string): boolean {
  return text.trim().length > 0
}

